import { useRef } from "react";
import ReactPlayer from "react-player";

import { usePlayerState } from "./contexts/player";

function Audio() {
  const { isPlaying, src, setLoading, setPlaybackError, volume } =
    usePlayerState();
  const player = useRef(null);

  if (isPlaying)
    return (
      <ReactPlayer
        playing={isPlaying}
        controls={false}
        url={src}
        height="0"
        width="0"
        volume={volume}
        ref={player}
        onPlay={() => setLoading(false)}
        onBuffer={() => setLoading(true)}
        onError={setPlaybackError}
      />
    );
  else return null;
}

export default Audio;
